@if (section(); as s) {
  <app-section-wrapper [id]="s.id" [title]="s.title" [background]="s.background">
    <div class="process-timeline">
      @for (step of s.items; track step.number; let last = $last) {
        <div class="process-step">
          <div class="process-step__left">
            <div class="process-step__circle">
              <span class="process-step__num">{{ step.number }}</span>
            </div>
            @if (!last) {
              <div class="process-step__line"></div>
            }
          </div>
          <div class="process-step__content">
            <div class="process-step__icon-wrap">
              <mat-icon>{{ step.icon }}</mat-icon>
            </div>
            <div>
              <h3 class="process-step__title">{{ step.title }}</h3>
              <p class="process-step__desc">{{ step.description }}</p>
            </div>
          </div>
        </div>
      }
    </div>
  </app-section-wrapper>
}
